import { render, staticRenderFns } from "./GamblingAccount.vue?vue&type=template&id=3346cec0&scoped=true&"
import script from "./GamblingAccount.vue?vue&type=script&lang=js&"
export * from "./GamblingAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3346cec0",
  null
  
)

export default component.exports